<template>
    <div class="stars">
        <img
            v-for="(_, idx) in full"
            :key="idx"
            src="@/common/images/stars/star-icon.svg"
        >
        <img
            v-if="half"
            src="@/common/images/stars/star-half-icon.svg"
        >
        <!-- 由于是同一父级， + maxStars 是防止 key 重复 -->
        <img
            v-for="(_, idx) in gray"
            :key="idx + maxStars"
            src="@/common/images/stars/star-gray-icon.svg"
        >
    </div>
</template>

<script>
/**
 * @file 星级评分
 * @author guozhihao02
 */
export default {
    props: {
        fullStars: {
            type: Number | String,
            default: 0
        },
        maxStars: {
            type: Number,
            default: 5
        }
    },
    computed: {
        half() {
            return +(parseInt(this.fullStars, 10) !== parseFloat(this.fullStars));
        },
        full() {
            return this.fullStars | 0;
        },
        gray() {
            return this.maxStars  - this.full - this.half;
        }
    }
};
</script>

<style lang="less" scoped>
.stars {
    display: flex;
    align-items: center;
    img {
        display: block;
        width: 18px;
        height: 18px;
    }
}
</style>
